import {
  reversed3umwqsxpi431x as reversed,
  take9j4462mea726 as take,
  chunked3v1tthtda414w as chunked,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__rangeTo_impl_1k0odj1ncwos3p2ntha as MonetaryValue__rangeTo_impl_1k0odj,
  _MonetaryValueRange___get_start__impl__vz87xnkvecqhn75yl7 as _MonetaryValueRange___get_start__impl__vz87xn,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  _MonetaryValue___get_inUsDollars__impl__m6itgm2hb63k79x57s7 as _MonetaryValue___get_inUsDollars__impl__m6itgm,
  MonetaryValueRange11s1xggovqdso as MonetaryValueRange,
  _MonetaryValue___get_inUsCents__impl__icg2cu1ffzqvrb4rbpl as _MonetaryValue___get_inUsCents__impl__icg2cu,
  _MonetaryValueRange___get_endInclusive__impl__m4ro0w3vpy6nx062q23 as _MonetaryValueRange___get_endInclusive__impl__m4ro0w,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_dp28ag147e4p5cz as get_dp } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { subtext2z3zzf0nosi4q as subtext } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { FormattedTextInput3hltc3nesrzjq as FormattedTextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/FormattedTextInput.commonHtml.mjs';
import { Companion_getInstance2v0f9t0g75gcs as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { coerceIn82duc7igyjd0 as coerceIn } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  startsWith1bgirhbedtv2y as startsWith,
  contains2el4s70rdq4ld as contains,
  substringAfter1hku067gwr5ve as substringAfter,
  substringBefore3n7kj60w69hju as substringBefore,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { abs22kdeprm0tm5i as abs } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  dividelr0uqtdj497z as divide,
  modulooi4g1kq3dmtt as modulo,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  reversed22y3au42jl32b as reversed_0,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function MonetaryValueInput$rView$lambda$lambda(it) {
  return reversed(it);
}
function FormattedTextInput$_get_keyboardHints_$ref_mteewo(p0) {
  return () => p0.ybr_1;
}
function FormattedTextInput$_set_keyboardHints_$ref_qhwqs4(p0) {
  return (_this__u8e3s4) => {
    p0.cbs(_this__u8e3s4);
    return Unit_instance;
  };
}
function FormattedTextInput$_get_hint_$ref_iu6w22(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.FormattedTextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.placeholder;
    var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function FormattedTextInput$_set_hint_$ref_61akla(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.FormattedTextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    p0.vb5_1.bb4_1.kb7_1.placeholder = _this__u8e3s4;
    return Unit_instance;
  };
}
function MonetaryValueInput$_get_hint_$ref_1pkf() {
  return (p0) => p0.idb();
}
function MonetaryValueInput$_set_hint_$ref_csulwd() {
  return (p0, p1) => {
    p0.vcl(p1);
    return Unit_instance;
  };
}
function MonetaryValueInput$_get_hint_$ref_1pkf_0() {
  return (p0) => p0.idb();
}
function MonetaryValueInput$_set_hint_$ref_csulwd_0() {
  return (p0, p1) => {
    p0.vcl(p1);
    return Unit_instance;
  };
}
function FormattedTextInput$_get_enabled_$ref_88xhgk(p0) {
  return () => p0.fbs();
}
function FormattedTextInput$_set_enabled_$ref_whse6o(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function MonetaryValueInput$_get_enabled_$ref_ui2o9t() {
  return (p0) => p0.fbs();
}
function MonetaryValueInput$_set_enabled_$ref_7ohxx() {
  return (p0, p1) => {
    p0.ebs(p1);
    return Unit_instance;
  };
}
function MonetaryValueInput$_get_enabled_$ref_ui2o9t_0() {
  return (p0) => p0.fbs();
}
function MonetaryValueInput$_set_enabled_$ref_7ohxx_0() {
  return (p0, p1) => {
    p0.ebs(p1);
    return Unit_instance;
  };
}
function RView$_get_shown_$ref_1dlfeq(p0) {
  return () => p0.yb8();
}
function RView$_set_shown_$ref_rx90zu(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function RView$_get_visible_$ref_5fyo75(p0) {
  return () => p0.ab9();
}
function RView$_set_visible_$ref_oufi4r(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function RView$_get_opacity_$ref_66h7g8(p0) {
  return () => p0.ib7();
}
function RView$_set_opacity_$ref_yk8o70(p0) {
  return (_this__u8e3s4) => {
    p0.gb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function RView$_get_dragData_$ref_6ct3r(p0) {
  return () => p0.jb9();
}
function RView$_set_dragData_$ref_fq3jnv(p0) {
  return (_this__u8e3s4) => {
    p0.ib9(_this__u8e3s4);
    return Unit_instance;
  };
}
function RView$_get_dropTargetDelegate_$ref_7ey0e6(p0) {
  return () => p0.lb9();
}
function RView$_set_dropTargetDelegate_$ref_to1gtu(p0) {
  return (_this__u8e3s4) => {
    p0.kb9(_this__u8e3s4);
    return Unit_instance;
  };
}
var MonetaryValueInputClass;
function MonetaryValueInput() {
  if (MonetaryValueInputClass === VOID) {
    class $ {
      constructor(writer) {
        this.ig9_1 = Signal().hak(new (MonetaryValue())(Companion_instance.r91(0n)));
        this.kg9_1 = MonetaryValue__rangeTo_impl_1k0odj(Companion_instance.p9s(-1000000000), Companion_instance.p9s(1000000000));
        var tmp = this;
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(writer.pc());
        var tmp0_elvis_lhs = writer.ebb_1;
        var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
        writer.gbb(p, view);
        view.zbm(false);
        view.bb9(get_dp(3));
        view.lbb(get_centered(view), subtext(view, '$'));
        var tmp_0 = view.kbb(get_centered(view), get_expanding(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.formattedTextInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (FormattedTextInput())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        this.jg9_1 = view_0;
        view_0.cbs(MonetaryValue__compareTo_impl_w7ul1r(_MonetaryValueRange___get_start__impl__vz87xn(this.kg9_1), Companion_instance.m62(0)) < 0 ? Companion_getInstance().xd5_1 : Companion_getInstance().wd5_1);
        var setting = {_v: false};
        var tmp_1 = (it) => {
          var tmp;
          if (equals(it, new (MonetaryValue())(Companion_instance.r91(0n)))) {
            tmp = '';
          } else if (setting._v) {
            setting._v = false;
            tmp = _MonetaryValue___get_inUsDollars__impl__m6itgm(it.y5r_1).toString();
          } else {
            tmp = MonetaryValue__toString_impl_xslc77(it.y5r_1);
          }
          return tmp;
        };
        view_0.zah(view_0.xbr_1, this.ig9_1.vak(tmp_1, (it) => {
          setting._v = true;
          var tmp0_elvis_lhs = Companion_instance.w9s(it);
          var tmp;
          var tmp_0 = tmp0_elvis_lhs;
          if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
            tmp = Companion_instance.r91(0n);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return coerceIn(new (MonetaryValue())(tmp), new (MonetaryValueRange())(this.kg9_1));
        }));
        var tmp_2 = (it) => isDigit(it.z2_1) || equals(it, new (Char())(_Char___init__impl__6a9atx(46))) || (equals(it, new (Char())(_Char___init__impl__6a9atx(45))) && MonetaryValue__compareTo_impl_w7ul1r(_MonetaryValueRange___get_start__impl__vz87xn(this.kg9_1), Companion_instance.m62(0)) < 0);
        view_0.bbs(tmp_2, (clean) => {
          var negative = startsWith(clean, _Char___init__impl__6a9atx(45));
          var decimal = contains(clean, _Char___init__impl__6a9atx(46));
          var centsStr = take(substringAfter(clean, _Char___init__impl__6a9atx(46), ''), 2);
          var tmp0_safe_receiver = Companion_instance.w9s(clean);
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = coerceIn(new (MonetaryValue())(tmp0_safe_receiver), new (MonetaryValueRange())(this.kg9_1)).y5r_1;
          }
          var tmp1_safe_receiver = tmp;
          var tmp_1;
          var tmp_2 = tmp1_safe_receiver;
          if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
            tmp_1 = null;
          } else {
            // Inline function 'com.crowpay.MonetaryValue.toDollarsAndCents' call
            // Inline function 'kotlin.math.absoluteValue' call
            var this_0 = _MonetaryValue___get_inUsCents__impl__icg2cu(tmp1_safe_receiver);
            // Inline function 'kotlin.Long.div' call
            var this_1 = abs(this_0);
            var tmp0 = divide(this_1, fromInt(100));
            // Inline function 'kotlin.math.absoluteValue' call
            var this_2 = _MonetaryValue___get_inUsCents__impl__icg2cu(tmp1_safe_receiver);
            // Inline function 'kotlin.Long.rem' call
            var this_3 = abs(this_2);
            var tmp2 = modulo(this_3, fromInt(100));
            _MonetaryValue___get_inUsCents__impl__icg2cu(tmp1_safe_receiver);
            var tmp_3;
            if (tmp0 === 0n && isBlank(substringBefore(clean, _Char___init__impl__6a9atx(46)))) {
              tmp_3 = '.' + centsStr;
            } else {
              var tmp_4;
              if (tmp2 === 0n) {
                // Inline function 'kotlin.text.isEmpty' call
                tmp_4 = charSequenceLength(centsStr) === 0;
              } else {
                tmp_4 = false;
              }
              if (tmp_4) {
                tmp_3 = tmp0.toString();
              } else {
                tmp_3 = tmp0.toString() + '.' + centsStr;
              }
            }
            tmp_1 = tmp_3;
          }
          var tmp2_elvis_lhs = tmp_1;
          var tmp_5;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.text.filter' call
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().d1();
            var inductionVariable = 0;
            var last = charSequenceLength(clean);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(clean, index);
                if (!(element === _Char___init__impl__6a9atx(45))) {
                  destination.xb(element);
                }
              }
               while (inductionVariable < last);
            tmp_5 = destination.toString();
          } else {
            tmp_5 = tmp2_elvis_lhs;
          }
          var clean2 = tmp_5;
          // Inline function 'kotlin.text.reversed' call
          var this_4 = substringBefore(clean2, _Char___init__impl__6a9atx(46));
          var tmp_6 = toString(reversed(isCharSequence(this_4) ? this_4 : THROW_CCE()));
          var preDecimal = joinToString(reversed_0(chunked(tmp_6, 3, MonetaryValueInput$rView$lambda$lambda)), ',');
          // Inline function 'kotlin.text.filterNot' call
          var tmp0_0 = substringAfter(clean2, _Char___init__impl__6a9atx(46), '');
          // Inline function 'kotlin.text.filterNotTo' call
          var destination_0 = StringBuilder().d1();
          var inductionVariable_0 = 0;
          while (inductionVariable_0 < charSequenceLength(tmp0_0)) {
            var element_0 = charSequenceGet(tmp0_0, inductionVariable_0);
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(element_0 === _Char___init__impl__6a9atx(46))) {
              destination_0.xb(element_0);
            }
          }
          var tmp$ret$13 = destination_0.toString();
          var postDecimal = take(tmp$ret$13, 2);
          return negative && decimal ? '-' + preDecimal + '.' + postDecimal : decimal ? preDecimal + '.' + postDecimal : negative ? '-' + preDecimal : preDecimal;
        });
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        writer.hbb(p, view);
        tmp.lg9_1 = view;
        var tmp_3 = this;
        var tmp0 = this.jg9_1;
        var tmp_4 = KMutableProperty0();
        var tmp_5 = FormattedTextInput$_get_keyboardHints_$ref_mteewo(tmp0);
        tmp_3.mg9_1 = getPropertyCallableRef('keyboardHints', 0, tmp_4, tmp_5, FormattedTextInput$_set_keyboardHints_$ref_qhwqs4(tmp0));
        var tmp_6 = this;
        var tmp0_0 = this.jg9_1;
        var tmp_7 = KMutableProperty0();
        var tmp_8 = FormattedTextInput$_get_hint_$ref_iu6w22(tmp0_0);
        tmp_6.ng9_1 = getPropertyCallableRef('hint', 0, tmp_7, tmp_8, FormattedTextInput$_set_hint_$ref_61akla(tmp0_0));
        var tmp_9 = this;
        var tmp0_1 = this.jg9_1;
        var tmp_10 = KMutableProperty0();
        var tmp_11 = FormattedTextInput$_get_enabled_$ref_88xhgk(tmp0_1);
        tmp_9.og9_1 = getPropertyCallableRef('enabled', 0, tmp_10, tmp_11, FormattedTextInput$_set_enabled_$ref_whse6o(tmp0_1));
        var tmp_12 = this;
        var tmp0_2 = this.lg9_1;
        var tmp_13 = KMutableProperty0();
        var tmp_14 = RView$_get_shown_$ref_1dlfeq(tmp0_2);
        tmp_12.pg9_1 = getPropertyCallableRef('shown', 0, tmp_13, tmp_14, RView$_set_shown_$ref_rx90zu(tmp0_2));
        var tmp_15 = this;
        var tmp0_3 = this.lg9_1;
        var tmp_16 = KMutableProperty0();
        var tmp_17 = RView$_get_visible_$ref_5fyo75(tmp0_3);
        tmp_15.qg9_1 = getPropertyCallableRef('visible', 0, tmp_16, tmp_17, RView$_set_visible_$ref_oufi4r(tmp0_3));
        var tmp_18 = this;
        var tmp0_4 = this.lg9_1;
        var tmp_19 = KMutableProperty0();
        var tmp_20 = RView$_get_opacity_$ref_66h7g8(tmp0_4);
        tmp_18.rg9_1 = getPropertyCallableRef('opacity', 0, tmp_19, tmp_20, RView$_set_opacity_$ref_yk8o70(tmp0_4));
        var tmp_21 = this;
        var tmp0_5 = this.lg9_1;
        var tmp_22 = KMutableProperty0();
        var tmp_23 = RView$_get_dragData_$ref_6ct3r(tmp0_5);
        tmp_21.sg9_1 = getPropertyCallableRef('dragData', 0, tmp_22, tmp_23, RView$_set_dragData_$ref_fq3jnv(tmp0_5));
        var tmp_24 = this;
        var tmp0_6 = this.lg9_1;
        var tmp_25 = KMutableProperty0();
        var tmp_26 = RView$_get_dropTargetDelegate_$ref_7ey0e6(tmp0_6);
        tmp_24.tg9_1 = getPropertyCallableRef('dropTargetDelegate', 0, tmp_25, tmp_26, RView$_set_dropTargetDelegate_$ref_to1gtu(tmp0_6));
      }
      dga(value) {
        this.kg9_1 = MonetaryValue__rangeTo_impl_1k0odj(_MonetaryValueRange___get_start__impl__vz87xn(this.kg9_1), value);
      }
      ega(value) {
        this.kg9_1 = MonetaryValue__rangeTo_impl_1k0odj(value, _MonetaryValueRange___get_endInclusive__impl__m4ro0w(this.kg9_1));
      }
      vcl(_set____db54di) {
        var tmp0 = this.ng9_1;
        var tmp = KMutableProperty1();
        var tmp_0 = MonetaryValueInput$_get_hint_$ref_1pkf_0();
        // Inline function 'kotlin.setValue' call
        getPropertyCallableRef('hint', 1, tmp, tmp_0, MonetaryValueInput$_set_hint_$ref_csulwd_0());
        tmp0.set(_set____db54di);
        return Unit_instance;
      }
      idb() {
        var tmp0 = this.ng9_1;
        var tmp = KMutableProperty1();
        var tmp_0 = MonetaryValueInput$_get_hint_$ref_1pkf();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('hint', 1, tmp, tmp_0, MonetaryValueInput$_set_hint_$ref_csulwd());
        return tmp0.get();
      }
      ebs(_set____db54di) {
        var tmp0 = this.og9_1;
        var tmp = KMutableProperty1();
        var tmp_0 = MonetaryValueInput$_get_enabled_$ref_ui2o9t_0();
        // Inline function 'kotlin.setValue' call
        getPropertyCallableRef('enabled', 1, tmp, tmp_0, MonetaryValueInput$_set_enabled_$ref_7ohxx_0());
        tmp0.set(_set____db54di);
        return Unit_instance;
      }
      fbs() {
        var tmp0 = this.og9_1;
        var tmp = KMutableProperty1();
        var tmp_0 = MonetaryValueInput$_get_enabled_$ref_ui2o9t();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('enabled', 1, tmp, tmp_0, MonetaryValueInput$_set_enabled_$ref_7ohxx());
        return tmp0.get();
      }
      qb9() {
        return this.jg9_1.qb9();
      }
    }
    initMetadataForClass($, 'MonetaryValueInput');
    MonetaryValueInputClass = $;
  }
  return MonetaryValueInputClass;
}
//region block: exports
export {
  MonetaryValueInput as MonetaryValueInput2lk8s753hzo22,
};
//endregion

//# sourceMappingURL=MonetaryValueInput.mjs.map
